var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import { ApTextField } from "./ApTextField";
export var ApTextFieldGridItem = function (props) {
    return (_jsx(Grid, __assign({ item: true, xs: props.xs, sx: props.sx }, { children: _jsx(ApTextField, { name: props.name, label: props.label, formik: props.formik, required: props.required, disabled: props.disabled, foolWidth: props.foolWidth, onKeyDown: props.onKeyDown, maxLength: props.maxLength, type: props.type, size: props.size, multiline: props.multiline, placeholder: props.placeholder, inputProps: props.inputProps }) })));
};
